import Container from "@/components/common/Container";
import Title from "./common/Title";


const Hero = () => (
  <Container className="bg-no-repeat bg-top md:bg-center bg-contain md:bg-cover overflow-y-hidden MobifinixHeroBg">
    <Container large>
      <p className="text-base  xl:text-lg font-light text-white pt-24 pb-48 md:pt-16 md:pb-9 xl:pb-52 xl:pt-24 w-1/2 md:w-full">
        <span className="font-jost">
          Blockchain Technology | UI/UX Case study
        </span>
      </p>
    </Container>
    <div className="overflow-hidden transition-all duration-1000 ease-in animate-slide-up">
      <Title
        className="w-full md:w-1/2"
        Description="MobifinX is an advanced, secured, scalable, robust, and flexible Digital Asset Trading Platform. It enables Banks, Institutional Investors, Hedge Funds, Cryptocurrency owners, Stock Exchanges & Broker-Dealers to efficiently roll out and scale the Trading Ecosystem with a multitude of Manual and Automated Trading services for consumers through multiple Products and creating a digital ecosystem."
        mainTitle="MobifinX"
      />
      <div className="flex flex-col md:flex-row pt-16 px-4 pb-10 md:pt-8 md:px-8 md:pb-16 xl:pt-48 xl:pb-24 xl:pl-14 xl:pr-0">
        <div className="w-full md:w-4/12 lg:w-3/12 mb-6 md:mb-0 ml-0 md:mr-4 lg:mr-6 rounded-xl xl:rounded-2xl bg-[#f8f8f91a] py-3 px-10 md:pl-4 md:pr-0 xl:py-6 xl:pl-8">
          <p className="text-base md:text-sm xl:text-base font-light text-white">
            <span className="font-jost">PROJECT TYPE</span>
          </p>
          <p className="text-base xl:text-lg font-normal text-white">
            <span className="font-jost">Web Design & Development</span>
          </p>
        </div>
        <div className="w-full md:w-4/12 lg:w-3/12 mb-6 md:mb-0 ml-0 md:mr-4 lg:mr-6 rounded-xl xl:rounded-2xl bg-[#f8f8f91a] py-3 px-10 md:pl-4 md:pr-0 xl:py-6 xl:pl-8">
          <p className="text-base md:text-sm xl:text-base font-light text-white">
            <span className="font-jost">CLIENT</span>
          </p>
          <p className="text-base xl:text-lg font-normal text-white">
            <span className="font-jost">MobifinX LLC, USA & India</span>
          </p>
        </div>
        <div className="w-full md:w-3/12 lg:w-2/12 rounded-xl xl:rounded-2xl bg-[#f8f8f91a] py-3 px-10 md:pl-4 md:pr-0 xl:py-6 xl:pl-8">
          <p className="text-base md:text-sm xl:text-base font-light text-white">
            <span className="font-jost">INDUSTRY</span>
          </p>
          <p className="text-base xl:text-lg font-normal text-white">
            <span className="font-jost">Fintech</span>
          </p>
        </div>
      </div>
    </div>
  </Container>
);
export default Hero;
